<template>
  <div class="modal-socials">
    <div>Следите за новостями Red Bull:</div>
    <div class="modal-socials__list">
      <AppBtn icon-only target="_blank" href="https://www.twitch.tv/redbullrus">
        <SvgIcon size="20" name="twitch" />
      </AppBtn>
      <AppBtn icon-only target="_blank" href="https://vk.com/redbullgaming">
        <SvgIcon size="20" name="vk" />
      </AppBtn>
      <AppBtn icon-only target="_blank" href="https://discord.gg/GNAVsJD">
        <SvgIcon size="20" name="discord" />
      </AppBtn>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalSocials"
};
</script>

<style lang="scss">
.modal-socials {
  font-weight: 700;
  font-size: 20px;

  @include breakpoint("sm-and-down") {
    font-size: 16px;
  }
}
</style>
